module.exports = __webpack_public_path__ + "img/tea0.4127be83.png";